import styled from "styled-components";

// สี/ขนาดตาม design S7 รอตรวจสลิป / S8 จองสำเร็จ + ตั๋ว
export const SeatBookingItemStyled = styled.div`
  margin-bottom: 16px;
  font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  color: ${({ theme }) => theme.COLORS.PURPLE_1};
  .sbi_booker {
    margin: 0 0 10px 6px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S13};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    word-break: break-word;
  }
  .sbi_card {
    padding: 12px 16px 16px;
    border-radius: 10px;
    background: #dbd2e4;
  }
  .sbi_status {
    padding: 5px 10px;
    border-radius: 20px;
    text-align: center;
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .sbi_payment {
    margin-top: 14px;
    .sbi_label {
      margin-bottom: 12px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S15};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
    }
    .sbi_amount_row {
      margin-top: 14px;
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      column-gap: 10px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .sbi_amount {
      font-size: ${({ theme }) => theme.FONT.SIZE.S13};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      white-space: nowrap;
    }
  }
  .sbi_text {
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    word-break: break-word;
  }
  .sbi_note {
    margin-top: 14px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    white-space: pre-line;
  }
  .sbi_tickets {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
  }
  .sbi_ticket {
    .ticket_title {
      margin-bottom: 12px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      word-break: break-word;
    }
    .ticket_qr {
      padding: 20px;
      border-radius: 10px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
    }
    .ticket_used {
      text-align: center;
      color: ${({ theme }) => theme.COLORS.GREEN_2};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    &.used {
      opacity: 0.8;
    }
  }
  .sbi_tickets + .sbi_note {
    text-align: center;
    font-size: ${({ theme }) => theme.FONT.SIZE.S11};
  }
`;
